
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const laser6d: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "6d-green-laser-treatment",
        "meta": {
            "title": "6D Green Laser Treatment for Weight Loss in Dubai | Elite Body Home",
            "description": "Get 6D Green Laser Treatment for Weight Loss in Dubai at Elite Body Home Polyclinic. Achieve your dream body with this non-invasive, effective solution designed to burn fat and improve body contour. Experience the best weight loss center in Dubai.",
            "robots": "index, follow",
            "canonical": "https://elitebodyhome.com/6d-green-laser-treatment-weight-loss-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Laser Treatment for Weight Loss in Dubai",
                "description": "Get 6D Green Laser Treatment for Weight Loss in Dubai at Elite Body Home Polyclinic. Achieve your dream body with this non-invasive, effective solution designed to burn fat and improve body contour. Experience the best weight loss center in Dubai.",
                "url": "https://elitebodyhome.com/6d-green-laser-treatment-weight-loss-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-16T12:37:52+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-39.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-39.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Laser Treatment for Weight Loss in Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Laser Treatment for Weight Loss in Dubai",
                "description": "Get 6D Green Laser Treatment for Weight Loss in Dubai at Elite Body Home Polyclinic. Achieve your dream body with this non-invasive, effective solution designed to burn fat and improve body contour. Experience the best weight loss center in Dubai.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-39.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "6D Green Laser Treatment"],
        "hero": {
            "title": "6D Green Laser Treatment in Dubai",
            "subtitle": "Non-Invasive Fat Reduction",
            "description": "The 6D Green Laser Treatment is an advanced aesthetic procedure that utilizes focused, specialized laser energy to target fat cells or micron-size fat particles that lie beneath the skin. The green laser wavelengths penetrate the skin and disrupt the fat cells, breaking them down while leaving the surrounding tissues unharmed. The fat cells that have been disrupted are naturally removed from the body via the lymphatic system. It is a painless treatment with zero downtime and is effective for all who are looking for fast weight loss results!"
        },
        "howItWorks": {
            "title": "How does 6D Green Laser Treatment work?",
            "description": "6D Green Laser Treatment – A technologically advanced procedure, employing focused laser energy to penetrate underneath the skin to eliminate resistant fat cells. Green laser wavelengths penetrate the skin and destroy the fat cells, rupturing them without damaging surrounding tissues. These disrupted fat cells are then naturally processed and removed by the body via the lymphatic system. It typically requires no downtime and causes no pain, which makes it a very convenient choice for anyone looking for quick and effective outcomes."
        },
        "procedureSteps": {
            "heading": "The 6D green laser treatment procedure consists of following steps",
            "para": "This advanced procedure follows a systematic approach to ensure effective fat reduction:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "You have a detailed assessment about your body aims and the areas to be treated and after that a detailed consultation.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "Area to be treated is cleaned and prepped for laser.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Laser Application",
                    "desc": "The 6D Green Laser device is passed over the area, delivering laser energy that passes through the skin and zeroes in on fat cells.",
                    "icon": "fa-solid fa-light-emergency"
                },
                {
                    "title": "Session Duration",
                    "desc": "Each session can take about 30-60 mins based on the areas one is being treated.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages Of 6D Green Laser Procedure",
            "subheading": "Why choose this advanced fat reduction treatment",
            "para": "This innovative treatment offers numerous benefits for those seeking non-invasive body contouring:",
            "items": [
                {
                    "title": "Non-Invasive",
                    "desc": "It does not require surgery, needles, anesthesia.",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "Targeted Fat Reduction",
                    "desc": "Fat loss in specific areas of the body, such as the abdomen, thighs, arms, and hips.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Quick Sessions",
                    "desc": "Every session is relatively short, so you can fit them into your busy schedule.",
                    "icon": "fa-solid fa-business-time"
                },
                {
                    "title": "No Downtime",
                    "desc": "You will be able to resume your typical activities right away after the procedure.",
                    "icon": "fa-solid fa-person-walking"
                },
                {
                    "title": "Painless",
                    "desc": "There is no pain or discomfort felt during or after the session, making the treatment quite comfortable.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Visible Results",
                    "desc": "Patients usually begin to notice improvements in their condition after a few treatment sessions but optimal results can be seen after completing the entire course of treatment.",
                    "icon": "fa-solid fa-eye"
                }
            ]
        },
        "eligibility": {
            "heading": "WHO IS THE 6D GREEN LASER TREATMENT FOR?",
            "subheading": "Ideal candidates for this advanced fat reduction procedure",
            "para": "Beginner-Friendly: 6D Green Laser Treatment is a simple and rapid fat reduction treatment that is suitable for a wide range of people, especially those looking for a non-invasive technique to eliminate fat and shape their bodies. But it's important to determine whether this type of treatment is a good match for your individual needs and health situation.",
            "items": [
                {
                    "title": "People Close to Their Ideal Weight",
                    "desc": "Ideal if you are near your target weight but have stubborn areas of fat.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "Healthy Adults",
                    "desc": "Those generally healthy and without serious medical conditions.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Non-Smokers",
                    "desc": "Non-smokers tend to have better results simply because smoking can interfere with circulation and healing.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Post-Pregnancy",
                    "desc": "Women who want to regain their pre-pregnancy shape by targeting areas like the tummy or hips.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "Realizing that this is a body contour solution and not a weight loss solution for large amounts of weight loss.",
                    "icon": "fa-solid fa-clipboard-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "What to Expect Before Your 6D Green Laser Procedure",
            "subheading": "How to prepare for optimal results",
            "para": "Preparation is important to ensure you get the most out of your 6D Green Laser Treatment. The process is simple and relatively minor, but there are things you can do to get the best results.",
            "items": [
                {
                    "title": "Consult Your Doctor",
                    "desc": "Make sure that you are a suitable candidate for the treatment, particularly if you hold any health-related conditions.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Hydrate well beforehand and after your session to help the body's natural detoxification processes.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid Heavy Meals",
                    "desc": "Have a light meal before your session so as not to feel uncomfortable during the treatment.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "Wearing loose, comfy clothing will help facilitate easy access to the area being treated.",
                    "icon": "fa-solid fa-shirt"
                },
                {
                    "title": "Avoid Alcohol and Caffeine",
                    "desc": "Do not drink alcohol or caffeinated products prior to the treatment — these can influence circulation and dehydration.",
                    "icon": "fa-solid fa-mug-hot"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "What to expect from your treatment",
            "para": "6D Green Laser Treatment offers gradual and remarkable results in the pursuit of a more sculpted body. It's important to note that a healthy lifestyle (proper exercise, balanced diet) is the basic step to ensure long-lasting results.",
            "items": [
                {
                    "title": "Visible Fat Reduction",
                    "desc": "Fat deposits in the treated areas are significantly reduced, creating a leaner and contoured appearance.",
                    "icon": "fa-solid fa-minus"
                },
                {
                    "title": "Improved Body Contour",
                    "desc": "More curves, slimmer profile, tighter bod.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Natural-Looking Results",
                    "desc": "Fat loss is a slow process, which means that the cosmetic outcome will not look 'off' when compared to the rest of your body.",
                    "icon": "fa-solid fa-face-grin-stars"
                },
                {
                    "title": "Boosted Confidence",
                    "desc": "But, hitting your body goals can be great for your self-confidence and self-image.",
                    "icon": "fa-solid fa-face-laugh-beam"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "Maintaining your results",
            "para": "To maximize and prolong your 6D Green Laser Treatment results, follow these recommendations:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Continue drinking plenty of water to help flush out the destroyed fat cells.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Maintain Healthy Diet",
                    "desc": "Follow a balanced diet to prevent new fat accumulation in treated areas.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "Regular Exercise",
                    "desc": "Combine your treatment with regular physical activity to enhance results.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "Follow-up Sessions",
                    "desc": "Consider additional sessions if needed for optimal results.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about 6D Green Laser Treatment",
            "items": [
                {
                    "question": "How many sessions will I need?",
                    "answer": "Most patients see noticeable results after 4-6 sessions, with maintenance sessions recommended as needed. The exact number depends on your goals and the areas being treated."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "No, the treatment is completely painless. Patients typically feel only a warm sensation during the procedure."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Some patients notice changes after the first session, but optimal results typically appear after completing the recommended course of treatments."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "There are typically no side effects, though some patients may experience mild redness or warmth in the treated area that subsides quickly."
                },
                {
                    "question": "Is the fat reduction permanent?",
                    "answer": "Yes, the destroyed fat cells are permanently eliminated. However, maintaining a stable weight is important to prevent remaining fat cells from expanding."
                },
                {
                    "question": "Who is not a good candidate?",
                    "answer": "This treatment is not suitable for pregnant women, individuals with certain medical conditions, or those with very loose skin."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "البطن",
                "title": "Abdomen",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/abdomen-laser.jpg"
            },
            {
                "ar": "الفخذين",
                "title": "Thighs",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/thighs-laser.jpg"
            },
            {
                "ar": "الذراعين",
                "title": "Arms",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/arms-laser.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "الجوانب",
                "title": "Flanks",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/flanks-laser.jpg"
            },
            {
                "ar": "الوركين",
                "title": "Hips",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/hips-laser.jpg"
            },
            {
                "ar": "الظهر",
                "title": "Back",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/back-laser.jpg"
            }
        ]
    },
    "ar": {
        "url": "6d-green-laser-treatment",
        "meta": {
            "title": "علاج الليزر الأخضر سداسي الأبعاد لإنقاص الوزن في دبي | ايليت بودي هوم",
            "description": "احصل على علاج الليزر الأخضر سداسي الأبعاد لإنقاص الوزن في دبي في عيادات ايليت بودي هوم. حقق حلمك بالحصول على الجسم المثالي بهذا الحل الفعال غير الجراحي المصمم لحرق الدهون وتحسين ملامح الجسم. جرب أفضل مركز لإنقاص الوزن في دبي.",
            "robots": "index, follow",
            "canonical": "https://elitebodyhome.com/6d-green-laser-treatment-weight-loss-dubai/",
            "og": {
                "title": "علاج الليزر الأخضر سداسي الأبعاد لإنقاص الوزن في دبي | ايليت بودي هوم",
                "description": "احصل على علاج الليزر الأخضر سداسي الأبعاد لإنقاص الوزن في دبي في عيادات ايليت بودي هوم. حقق حلمك بالحصول على الجسم المثالي بهذا الحل الفعال غير الجراحي المصمم لحرق الدهون وتحسين ملامح الجسم.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-39.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "علاج الليزر الأخضر سداسي الأبعاد"],
        "hero": {
            "title": "علاج الليزر الأخضر سداسي الأبعاد لإنقاص الوزن في دبي",
            "subtitle": "الليزر الأخضر سداسي الأبعاد: حدد قوامك، وارفع مستوى ثقتك بنفسك",
            "description": "يُعد علاج الليزر الأخضر سداسي الأبعاد إجراءً تجميليًا متطورًا، يستخدم طاقة ليزر مركزة ومتخصصة لاستهداف الخلايا الدهنية أو الجزيئات الدقيقة من الدهون الموجودة تحت الجلد. تخترق أطوال موجات الليزر الأخضر طبقات الجلد لتفتيت الخلايا الدهنية بفاعلية خلال جلسات التخسيس بالليزر، مع الحفاظ على سلامة الأنسجة المحيطة دون أي ضرر. تُزال الخلايا الدهنية المُفتتة بشكل طبيعي من الجسم عبر الجهاز اللمفاوي. يُعد هذا العلاج غير مؤلم تمامًا ولا يتطلب فترة تعافي، وهو خيار مثالي لكل من يبحث عن نتائج سريعة وفعالة لإنقاص الوزن!"
        },
        "howItWorks": {
            "title": "كيف يعمل علاج الليزر الأخضر سداسي الأبعاد؟",
            "description": "يُعد علاج الليزر الأخضر سداسي الأبعاد إجراءً متطورًا لتنحيف الجسم، يستخدم طاقة ليزر مركزة لاختراق طبقات الجلد العميقة لاستهداف الخلايا الدهنية العنيدة والقضاء عليها. تخترق أطوال موجات الليزر الأخضر الجلد لتفتيت الخلايا الدهنية دون أن تُلحق أي ضرر بالأنسجة المحيطة. بعد تدميرها، يقوم الجسم بالتخلص من هذه الخلايا الدهنية المتفككة بشكل طبيعي عبر الجهاز اللمفاوي. العلاج غير مؤلم تمامًا ولا يتطلب فترة تعافٍ، مما يجعله خيارًا مثاليًا لكل من يرغب في الحصول على نتائج سريعة وفعالة في تقليل الدهون من الجسم."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء علاج الليزر الأخضر سداسي الأبعاد",
            "para": "يتبع هذا الإجراء المتطور نهجًا منهجيًا لضمان تحقيق نتائج فعالة في تقليل الدهون:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يبدأ العلاج بجلسة تقييم شاملة لمناقشة أهدافك والمناطق المراد معالجتها، يليها استشارة تفصيلية مع طبيب متخصص.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف المنطقة المستهدفة جيدًا لتحضيرها لعلاج الليزر.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "توجيه الليزر",
                    "desc": "يُمرر جهاز الليزر الأخضر سداسي الأبعاد فوق المنطقة المحددة، حيث يوفر طاقة ليزر تخترق الجلد وتستهدف الخلايا الدهنية.",
                    "icon": "fa-solid fa-light-emergency"
                },
                {
                    "title": "مدة الجلسة",
                    "desc": "تستغرق كل جلسة ما بين 30 إلى 60 دقيقة، حسب حجم وعدد المناطق التي تتم معالجتها.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد علاج الليزر الأخضر سداسي الأبعاد",
            "subheading": "لماذا تختار هذا العلاج المتطور لتقليل الدهون",
            "para": "يقدم هذا العلاج المبتكر العديد من المزايا لمن يبحثون عن نحت الجسم غير الجراحي:",
            "items": [
                {
                    "title": "إجراء غير جراحي",
                    "desc": "لا يتطلب أي تدخل جراحي أو استخدام للإبر أو التخدير.",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "استهداف الدهون العنيدة",
                    "desc": "يساعد على التخلص من الدهون في مناطق معينة من الجسم مثل البطن، والفخذين، والذراعين، والوركين.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "جلسات سريعة",
                    "desc": "تُعد جلسة العلاج قصيرة نسبيًا، مما يجعل من السهل دمجها ضمن جدولك اليومي المزدحم.",
                    "icon": "fa-solid fa-business-time"
                },
                {
                    "title": "لا يتطلب فترة تعافي",
                    "desc": "يمكنك العودة لممارسة أنشطتك المعتادة فورًا بعد الجلسة دون الحاجة إلى فترة راحة.",
                    "icon": "fa-solid fa-person-walking"
                },
                {
                    "title": "إجراء غير مؤلم",
                    "desc": "لا يسبب العلاج أي ألم أو إزعاج أثناء الجلسة أو بعدها، مما يجعله تجربة مريحة للغاية.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "نتائج واضحة",
                    "desc": "يبدأ معظم المرضى بملاحظة تحسن بعد عدة جلسات، بينما تظهر النتائج المثالية عادةً بعد الانتهاء الكامل من البرنامج العلاجي.",
                    "icon": "fa-solid fa-eye"
                }
            ]
        },
        "eligibility": {
            "heading": "لمن يناسب علاج الليزر الأخضر سداسي الأبعاد؟",
            "subheading": "المرشحون المثاليون لهذا الإجراء المتطور لتقليل الدهون",
            "para": "مناسب للمبتدئين: يُعد علاج الليزر الأخضر سداسي الأبعاد خيارًا بسيطًا وسريعًا لتقليل الدهون، ويناسب مجموعة واسعة من الأشخاص، خاصًة الذين يبحثون عن طريقة غير جراحية للتقليل الدهون ونحت أجسامهم. يجب تحديد ما إذا كان هذا العلاج مناسبًا لحالتك الصحية وأهدافك الشخصية.",
            "items": [
                {
                    "title": "الأشخاص الذين يتقارب وزنهم مع الوزن المثالي",
                    "desc": "سيناسبك العلاج إذا كان وزنك قريب من الوزن المستهدف وتعاني من تراكم الدهون العنيدة في مناطق محددة.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "البالغون الأصحاء",
                    "desc": "يُعد العلاج مناسب للأشخاص الذين يتمتعون بصحة عامة جيدة ولا يعانون من مشكلات طبية خطيرة.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "غير المدخنين",
                    "desc": "تظهر النتائج بشكل أفضل لدى غير المدخنين، لأن التدخين قد يؤثر سلبًا على الدورة الدموية وعملية الشفاء.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "النساء في مرحلة ما بعد الحمل",
                    "desc": "يلائم العلاج للسيدات اللاتي يرغبن في استعادة شكل أجسامهن بعد الولادة، خصوصًا في مناطق مثل البطن أو الوركين.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "توقعات واقعية عن النتائج",
                    "desc": "يلائم الأشخاص الذين يدركون أن العلاج هدفه نحت الجسم، وليس إنقاص وزن كبير.",
                    "icon": "fa-solid fa-clipboard-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "ماذا تتوقع قبل الخضوع لعلاج الليزر الأخضر سداسي الأبعاد؟",
            "subheading": "كيف تستعد لتحقيق أفضل النتائج",
            "para": "تُعد الاستعدادات جزءاً أساسياً من العلاج لضمان تحقيق أفضل النتائج من علاج الليزر الأخضر سداسي الأبعاد، حيث إنه إجراء بسيط ولا يتطلب تحضيرات معقدة، ولكن سيساعدك اتباع بعض التعليمات على تحقيق أقصى استفادة.",
            "items": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "تأكد من أنك مرشح مناسب للعلاج، خاصة إذا كنت تعاني من أي حالات صحية تتطلب اهتماماً خاصاً.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "الحفاظ على ترطيب جسمك",
                    "desc": "اشرب كمية كافية من الماء قبل الجلسة وبعدها، لدعم عملية التخلص من السموم في الجسم.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب الوجبات الثقيلة",
                    "desc": "تناول وجبة خفيفة قبل الجلسة، لتجنب الشعور بالانزعاج أثناء العلاج.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "اختر ملابس فضفاضة ومريحة، لتسهيل الوصول إلى المنطقة المستهدفة للعلاج.",
                    "icon": "fa-solid fa-shirt"
                },
                {
                    "title": "تجنب الكحول والكافيين",
                    "desc": "امتنع عن تناول المشروبات الكحولية أو الغنية بالكافيين قبل الجلسة، لأنها قد تؤثر على الدورة الدموية وتسبب الجفاف.",
                    "icon": "fa-solid fa-mug-hot"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "ما يمكن توقعه من العلاج",
            "para": "يقدم علاج الليزر الأخضر سداسي الأبعاد نتائج تدريجية وملحوظة في رحلة الحصول على جسم أكثر تحديدًا. يجب معرفة أن اتباع نمط حياة صحي مثل ممارسة التمارين الرياضية بانتظام واتباع نظام غذائي متوازن هو الأساس للحفاظ على النتائج لفترة طويلة.",
            "items": [
                {
                    "title": "تقليل واضح في تراكم الدهون",
                    "desc": "ستلاحظ انخفاض ملحوظ في تراكمات الدهون في المناطق المعالجة، مما يمنح الجسم مظهراً أنحف وأكثر تحديدًا.",
                    "icon": "fa-solid fa-minus"
                },
                {
                    "title": "تحسين ملامح الجسم",
                    "desc": "تظهر منحنيات طبيعية للجسم، وقوام أكثر رشاقة وجسم أكثر تماسكًا.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "تقل الدهون بشكل تدريجي، مما يضمن أن التغيرات في مظهر الجسم تكون طبيعية ومتناسقة مع باقي أجزاء الجسم.",
                    "icon": "fa-solid fa-face-grin-stars"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "تحقيق أهدافك الجسدية ينعكس بشكل إيجابي على ثقتك بنفسك وصورتك الذاتية.",
                    "icon": "fa-solid fa-face-laugh-beam"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح العناية بعد الجلسة",
            "subheading": "للحفاظ على النتائج",
            "para": "لتعظيم النتائج وإطالة أمدها بعد علاج الليزر الأخضر سداسي الأبعاد، ننصح باتباع هذه التوصيات:",
            "items": [
                {
                    "title": "الحفاظ على ترطيب الجسم",
                    "desc": "استمر في شرب كميات كافية من الماء للمساعدة في التخلص من الخلايا الدهنية المدمرة.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "اتباع نظام غذائي صحي",
                    "desc": "حافظ على نظام غذائي متوازن لمنع تراكم الدهون الجديدة في المناطق المعالجة.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "ممارسة الرياضة بانتظام",
                    "desc": "اجمع بين العلاج والنشاط البدني المنتظم لتعزيز النتائج.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "فكر في جلسات إضافية إذا لزم الأمر للحصول على نتائج مثالية.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "أسئلة شائعة حول علاج الليزر الأخضر سداسي الأبعاد",
            "items": [
                {
                    "question": "كم عدد الجلسات التي سأحتاجها؟",
                    "answer": "يلاحظ معظم المرضى نتائج ملحوظة بعد 4-6 جلسات، مع جلسات صيانة موصى بها حسب الحاجة. يعتمد العدد الدقيق على أهدافك والمناطق التي يتم علاجها."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "لا، العلاج غير مؤلم تمامًا. يشعر المرضى عادةً بإحساس دافئ فقط أثناء الإجراء."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "يلاحظ بعض المرضى تغيرات بعد الجلسة الأولى، ولكن النتائج المثالية تظهر عادةً بعد إكمال الدورة العلاجية الموصى بها."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "لا توجد عادةً أي آثار جانبية، على الرغم من أن بعض المرضى قد يعانون من احمرار خفيف أو دفء في المنطقة المعالجة يزول بسرعة."
                },
                {
                    "question": "هل تقليل الدهون دائم؟",
                    "answer": "نعم، يتم التخلص من الخلايا الدهنية المدمرة بشكل دائم. ومع ذلك، من المهم الحفاظ على وزن ثابت لمنع الخلايا الدهنية المتبقية من التضخم."
                },
                {
                    "question": "من ليس مرشحًا جيدًا؟",
                    "answer": "هذا العلاج غير مناسب للنساء الحوامل أو الأفراد الذين يعانون من حالات طبية معينة أو الذين يعانون من جلد مترهل جدًا."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "البطن",
                "title": "البطن",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/abdomen-laser.jpg"
            },
            {
                "ar": "الفخذين",
                "title": "الفخذين",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/thighs-laser.jpg"
            },
            {
                "ar": "الذراعين",
                "title": "الذراعين",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/arms-laser.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "الجوانب",
                "title": "الجوانب",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/flanks-laser.jpg"
            },
            {
                "ar": "الوركين",
                "title": "الوركين",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/hips-laser.jpg"
            },
            {
                "ar": "الظهر",
                "title": "الظهر",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/back-laser.jpg"
            }
        ]
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-39.jpg",
            "beforeAfter": [
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/6D-Green-Laser-Treatment-for-Weight-Loss-in-Dubai-1.jpg",
                    "alt": "6D Green Laser Treatment for Weight Loss in Dubai"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/6D-Green-Laser-Treatment-for-Weight-Loss-in-Dubai-2.jpg",
                    "alt": "6D Green Laser Treatment for Weight Loss in Dubai"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/6D-Green-Laser-Treatment-for-Weight-Loss-in-Dubai-3.jpg",
                    "alt": "6D Green Laser Treatment for Weight Loss in Dubai"
                }
            ]
        },
        "product": {
            "id": 4,
            "title": "6D Green Laser Treatment in Dubai",
            "description": "Advanced non-invasive fat reduction using green laser technology to target and eliminate fat cells for improved body contouring. Painless treatment with no downtime.",
            "price": 1500
        }
    }
}